export const SUPPORT_EMAIL = "assistance@chenia.app";

const SUPPORT = {
  fr: {
    title: "Contact / Assistance",
    intro: "Une question, un souci avec votre compte, votre programme ou votre abonnement ? Écrivez-nous, nous vous répondons avec plaisir.",
    email_h: "Nous écrire",
    email_p: "Adresse de l'assistance CHENIA (site web et applications iOS / Android) :",
    email_btn: "Envoyer un e-mail",
    tips_h: "Pour une réponse plus rapide",
    tips: [
      "L'adresse e-mail de votre compte CHENIA.",
      "L'appareil utilisé (ordinateur, iPhone, Android) et, pour l'application, sa version.",
      "Une description du problème et, si possible, une capture d'écran.",
    ],
    topics_h: "Questions fréquentes",
    topics: [
      { h: "Abonnement souscrit sur le site", p: "Gérez, modifiez ou résiliez votre abonnement depuis Paramètres → Abonnement, à tout moment." },
      { h: "Abonnement souscrit dans l'App Store ou Google Play", p: "Il se gère directement dans les réglages de votre compte Apple ou Google (abonnements). Les remboursements suivent les règles d'Apple ou de Google." },
      { h: "Supprimer mon compte", p: "Vous pouvez supprimer votre compte et vos données à tout moment, depuis l'application ou via la page dédiée." },
      { h: "Vos données", p: "La politique de confidentialité décrit les données traitées et vos droits." },
    ],
    delete_link: "Supprimer mon compte",
    privacy_link: "Politique de confidentialité",
    back_home: "Retour à l'accueil",
  },
  en: {
    title: "Contact / Support",
    intro: "A question or an issue with your account, your meal plan or your subscription? Write to us — we'll be happy to help.",
    email_h: "Write to us",
    email_p: "CHENIA support address (website and iOS / Android apps):",
    email_btn: "Send an email",
    tips_h: "For a faster answer",
    tips: [
      "The email address of your CHENIA account.",
      "The device you use (computer, iPhone, Android) and, for the app, its version.",
      "A description of the problem and, if possible, a screenshot.",
    ],
    topics_h: "Frequently asked questions",
    topics: [
      { h: "Subscription purchased on the website", p: "Manage, change or cancel your subscription at any time from Settings → Subscription." },
      { h: "Subscription purchased in the App Store or Google Play", p: "It is managed directly in your Apple or Google account settings (subscriptions). Refunds follow Apple's or Google's rules." },
      { h: "Delete my account", p: "You can delete your account and your data at any time, from the app or via the dedicated page." },
      { h: "Your data", p: "The privacy policy describes the data processed and your rights." },
    ],
    delete_link: "Delete my account",
    privacy_link: "Privacy policy",
    back_home: "Back to home",
  },
  de: {
    title: "Kontakt / Support",
    intro: "Eine Frage oder ein Problem mit Ihrem Konto, Ihrem Essensplan oder Ihrem Abonnement? Schreiben Sie uns – wir helfen gerne.",
    email_h: "Schreiben Sie uns",
    email_p: "Support-Adresse von CHENIA (Website und iOS- / Android-Apps):",
    email_btn: "E-Mail senden",
    tips_h: "Für eine schnellere Antwort",
    tips: [
      "Die E-Mail-Adresse Ihres CHENIA-Kontos.",
      "Das verwendete Gerät (Computer, iPhone, Android) und bei der App deren Version.",
      "Eine Beschreibung des Problems und, wenn möglich, ein Screenshot.",
    ],
    topics_h: "Häufige Fragen",
    topics: [
      { h: "Abonnement über die Website abgeschlossen", p: "Verwalten, ändern oder kündigen Sie Ihr Abonnement jederzeit unter Einstellungen → Abonnement." },
      { h: "Abonnement im App Store oder bei Google Play abgeschlossen", p: "Es wird direkt in den Einstellungen Ihres Apple- oder Google-Kontos (Abonnements) verwaltet. Rückerstattungen richten sich nach den Regeln von Apple bzw. Google." },
      { h: "Mein Konto löschen", p: "Sie können Ihr Konto und Ihre Daten jederzeit löschen – in der App oder über die eigene Seite." },
      { h: "Ihre Daten", p: "Die Datenschutzerklärung beschreibt die verarbeiteten Daten und Ihre Rechte." },
    ],
    delete_link: "Mein Konto löschen",
    privacy_link: "Datenschutzerklärung",
    back_home: "Zurück zur Startseite",
  },
  it: {
    title: "Contatto / Assistenza",
    intro: "Una domanda o un problema con il tuo account, il tuo piano pasti o il tuo abbonamento? Scrivici, saremo felici di aiutarti.",
    email_h: "Scrivici",
    email_p: "Indirizzo dell'assistenza CHENIA (sito web e app iOS / Android):",
    email_btn: "Invia un'e-mail",
    tips_h: "Per una risposta più rapida",
    tips: [
      "L'indirizzo e-mail del tuo account CHENIA.",
      "Il dispositivo utilizzato (computer, iPhone, Android) e, per l'app, la sua versione.",
      "Una descrizione del problema e, se possibile, uno screenshot.",
    ],
    topics_h: "Domande frequenti",
    topics: [
      { h: "Abbonamento sottoscritto sul sito", p: "Gestisci, modifica o disdici il tuo abbonamento in qualsiasi momento da Impostazioni → Abbonamento." },
      { h: "Abbonamento sottoscritto nell'App Store o su Google Play", p: "Si gestisce direttamente nelle impostazioni del tuo account Apple o Google (abbonamenti). I rimborsi seguono le regole di Apple o Google." },
      { h: "Eliminare il mio account", p: "Puoi eliminare il tuo account e i tuoi dati in qualsiasi momento, dall'app o tramite la pagina dedicata." },
      { h: "I tuoi dati", p: "L'informativa sulla privacy descrive i dati trattati e i tuoi diritti." },
    ],
    delete_link: "Eliminare il mio account",
    privacy_link: "Informativa sulla privacy",
    back_home: "Torna alla home",
  },
};

export const supportFor = (lang) => SUPPORT[lang] || SUPPORT.fr;
